import { useContext } from "react";

import { useAdminAirlineApi } from "../../../../airline/common/api/useAdminAirlineApi";
import { SystemPlatformDetailsContext } from "../../context/SystemPlatformDetailsContext";
import { EditShreqIdsFormInputs } from "./EditShreqIdsForm";

export const useEditShreqIdsForm = (systemId: string) => {
    const { updateShreqIds } = useAdminAirlineApi();

    const { systemPlatformDetailsItem, updateShreqIds: updateShreqIdsItem } = useContext(SystemPlatformDetailsContext);

    const itemToEdit = systemPlatformDetailsItem.shreqIds;

    const editShreqIds = async ({ shreqIds }: EditShreqIdsFormInputs) => {
        const shreqIdValues = shreqIds.map((shreqId) => shreqId.value).filter(Boolean);

        await updateShreqIds({
            airlineId: systemPlatformDetailsItem.airline.id,
            systemId,
            shreqIds: shreqIdValues
        });

        updateShreqIdsItem(shreqIdValues);
    };

    return {
        itemToEdit,
        editShreqIds
    };
};
